<template>
  <div>
    <div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-33">
          <md-field :class="!checkPercentage(typeInfo.cover) ? 'md-invalid' : ''">
            <label for="cover">{{ $t("typeInfo.cover.shrubs") }} %</label>
            <md-input type="number" name="cover" v-model="typeInfo.cover" />
            <span class="md-error">{{ $t("error.errorRange") }} (0-100)</span>
          </md-field>
        </div>
        <div class="md-layout-item md-size-33">
          <md-field :class="!checkRange(typeInfo.trees_nr, 0, 99999) ? 'md-invalid' : ''">
            <label for="treesNr">{{ $t("typeInfo.trees") }} N°</label>
            <md-input type="number" name="treesNr" v-model="typeInfo.trees_nr" />
            <span class="md-error">{{ $t("error.errorRange") }} (0-99999)</span>
          </md-field>
        </div>
        <div class="md-layout-item md-size-33">
          <md-field>
            <select v-model="typeInfo.plot_area" name="plotArea">
              <option disabled value="">{{ $t("typeInfo.plotArea") }}</option>
              <option v-for="area in areas" :value="area" :key="area">{{ area }} m²</option>
            </select>
          </md-field>
        </div>
      </div>

      <div v-for="(ts, i) in typeInfo.species" class="md-layout md-gutter" :key="i">
        <div class="md-layout-item md-size-90" v-if="ts !== null">
          <md-field>
            <std-autocomplete
              v-if="loadStd"
              :data="stdList"
              :label="$t('typeInfo.woodSpecies')"
              :initialValue="ts.specie_std2"
              :initialDisplay="initSpecie[i]"
              :index="i"
              @result="getSpecie"></std-autocomplete>
          </md-field>
        </div>
        <div class="md-layout-item md-size-10" v-if="ts !== null">
          <md-icon @click.native="removeSpecie(i)" v-show="btn.rm">clear</md-icon>
        </div>

        <div class="md-layout-item md-size-50" v-if="ts !== null">
          <md-field :class="!checkAvd(ts.avg_diameter) ? 'md-invalid' : ''">
            <label for="avd">{{ $t("typeInfo.specieAvd") }} (cm)</label>
            <md-input type="number" step="0.01" name="avd" v-model="ts.avg_diameter" />
            <span class="md-error">{{ $t("error.errorRange") }} (0-100)</span>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50" v-if="ts !== null">
          <md-field :class="!checkAvh(ts.avg_height) ? 'md-invalid' : ''">
            <label for="avh">{{ $t("typeInfo.specieAvh") }} (cm)</label>
            <md-input type="number" step="0.01" name="avh" v-model="ts.avg_height" />
            <span class="md-error">{{ $t("error.errorRange") }} (0-300)</span>
          </md-field>
        </div>
      </div>

      <div class="md-layout md-gutter md-alignment-center-center">
        <md-button class="md-raised md-primary" @click="addSpecie()" v-show="btn.add">{{ $t("global.add") }} {{ $t('global.specie') }}</md-button>
      </div>

      <div class="md-layout md-gutter md-alignment-center-center">
        <md-button class="md-raised md-primary" @click="addNw()" v-show="btn.nw">{{ btnAddNw }}</md-button>
      </div>
    </div>

    <error-dialog :show="error" :text="$t('error.dataCheck')" @closeError="error = false" />
  </div>
</template>

<script>
import StdAutocomplete from '@/components/StdAutocomplete'
import ErrorDialog from '@/components/ErrorDialog'

import EventBus from '@/event-bus'
import { getDomain } from '@/assets/scripts/domainsManager'
import { checkAvd, checkAvh, checkPercentage, checkRange, normalize, formatList, getValue } from '@/assets/scripts/formatData'

const STD2 = 'std2'

const SPECIE = {
  specie_std2: '',
  avg_diameter: null,
  avg_height: null
}

const MAX_SPECIE = 7

export default {
  props: ['radius'],
  components: {
    StdAutocomplete,
    ErrorDialog
  },
  data: () => ({
    typeInfo: {
      cover: null,
      plot_area: 25,
      plot_radius: null,
      species: [{ ...SPECIE }],
      trees_nr: null
    },
    areas: [
      25,
      200,
      400
    ],
    stdList: [],
    btn: {
      rm: false,
      add: true,
      nw: true
    },
    btnAddNw: '',
    edit: false,
    loadStd: false,
    initSpecie: [],
    checkPercentage: checkPercentage,
    checkAvd: checkAvd,
    checkAvh: checkAvh,
    checkRange: checkRange,
    error: false
  }),
  mounted () {
    this.typeInfo.plot_radius = this.radius
    this.$store.state.plot.id === null ? this.edit = false : this.edit = true
    this.setLists()

    if (this.edit) {
      this.typeInfo = this.$store.state.plot.typeInfo // ref to store
      this.setSpecie()
    }

    if (this.edit && this.$store.state.plot.typeInfo.nonwood !== undefined) { // existing nonwood to edit
      this.btnAddNw = this.$i18n.t('global.edit') + ' ' + this.$i18n.t('plot.plotTypeList.nonwood')
    } else {
      this.btnAddNw = this.$i18n.t('global.add') + ' ' + this.$i18n.t('plot.plotTypeList.nonwood')
    }

    EventBus.$on('save', () => {
      this.saveData()
    })
  },
  computed: {
    area () {
      return this.typeInfo.plot_area
    }
  },
  watch: {
    area () {
      this.$emit('area', this.typeInfo.plot_area)
    },
    radius: function () {
      this.typeInfo.plot_radius = this.radius
    }
  },
  methods: {
    saveData: function () {
      if (this.checkData()) {
        this.typeInfo.species = this.typeInfo.species.filter(el => {
          return el != null
        })
        if (this.typeInfo.cover !== null) this.typeInfo.cover = normalize(this.typeInfo.cover, 0)
        if (this.typeInfo.trees_nr !== null) this.typeInfo.trees_nr = normalize(this.typeInfo.trees_nr, 0)
        // send data only in new
        this.edit ? this.$emit('typeInfo', null) : this.$emit('typeInfo', this.typeInfo)
      } else {
        this.error = true
      }
    },

    setLists: function () {
      getDomain(STD2).then(data => {
        this.stdList = formatList(data[this.$i18n.locale])
        if (this.edit) {
          this.typeInfo.species.forEach((specie, i) => {
            this.initSpecie[i] = getValue(this.stdList, specie.specie_std2)
          })
        }
        this.loadStd = true
      })
    },

    addSpecie: function () {
      this.typeInfo.species.push({ ...SPECIE })
      this.btn.rm = true
      if (this.getLength() === MAX_SPECIE) {
        this.btn.add = false
      }
    },

    removeSpecie: function (index) {
      this.$set(this.typeInfo.species, index, null)
      this.btn.add = true
      if (this.getLength() === 1) {
        this.btn.rm = false
      }
    },

    addNw: function () {
      // send the tmp info to the parent only in new
      this.edit ? this.$emit('tmpInfo', null) : this.$emit('tmpInfo', this.typeInfo)
    },

    setSpecie: function () {
      if (this.getLength() > 1) {
        this.btn.rm = true
        if (this.getLength() === MAX_SPECIE) {
          this.btn.add = false
        }
      }
    },

    getSpecie: function (value, index) {
      this.typeInfo.species[index].specie_std2 = value
    },

    getLength: function () {
      let length = 0
      this.typeInfo.species.filter(el => {
        if (el != null) length++
      })

      return length
    },

    checkData: function () {
      let checkSpecie = true
      this.typeInfo.species.forEach(specie => {
        if (specie !== null) {
          if (!checkAvd(specie.avg_diameter)) checkSpecie = false
          if (!checkAvh(specie.avg_height)) checkSpecie = false
        }
      })

      return checkPercentage(this.typeInfo.cover) && checkRange(this.typeInfo.trees_nr, 0, 99999) && checkSpecie
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
